import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['message']

  messageTargetConnected(target) {
    setTimeout(() => {
      this.closeMessage(target)
    }, 8000)
  }

  dismiss(event) {
    this.closeMessage(event.currentTarget.parentNode)
  }

  closeMessage(target) {
    target.classList.add('opacity-0')

    setTimeout(() => {
      target.remove()
    }, 500)
  }
}
